import TtamCreativeDefferedDeepLinkInput from './input/index.vue';
import TtamCreativeDefferedDeepLinkSwitch from './switch/index.vue';
import TtamCreativeDefferedDeepLinkDpaSelect from './dpa-select/index.vue';
import TtamCreativeDefferedDeepLinkDpaInputFormLabel from './dpa-input-form-label/index.vue';
import TtamCreativeDefferedDeepLinkDpaProductLink from './dpa-product-link/index.vue';

import * as hooks from './hooks';
export default {
  TtamCreativeDefferedDeepLinkInput,
  TtamCreativeDefferedDeepLinkSwitch,
  TtamCreativeDefferedDeepLinkDpaSelect,
  TtamCreativeDefferedDeepLinkDpaInputFormLabel,
  TtamCreativeDefferedDeepLinkDpaProductLink,
  ...hooks,
};
